import SellWithUsImhg from "@/assets/common/SellWithUs.webp";
import Button from "@/components/Atoms/Button";
import Image from "@/components/Atoms/Image";
import { Link } from "react-router-dom";
import { StyledWrapperGradient } from "./styles";
import Heading from "@/components/Atoms/Heading";
import Paragraph from "@/components/Atoms/Paragraph";

const SellWithUsBanner = () => {
  return (
    <StyledWrapperGradient>
      <div>
        <div>
          <Heading className="SellWithUsBanner-title">¿Quieres ver tus productos en fithub?</Heading>

          <Paragraph sizeVariant="md" className="SellWithUsBanner-text">
            Déjanos tus datos y te contactaremos.
            <br />
            Nos encantaría vender tus productos en fithub.
          </Paragraph>
        </div>

        <Button
          sizeVariant="md"
          color="secondary"
          variant="outlined"
          as={Link}
          to="https://leads-fithub.subrik.com"
          title="Ser aliado Fithub"
          target="_blank"
        >
          Quiero ser aliado
        </Button>
      </div>

      <figure>
        <Image
          src={SellWithUsImhg}
          alt="Déjanos tus datos y te contactaremos. Nos encantaría vender tus productos en fithub."
          title="Déjanos tus datos y te contactaremos. Nos encantaría vender tus productos en fithub."
        />
      </figure>
    </StyledWrapperGradient>
  );
};

export default SellWithUsBanner;
